<div class="audio-record-train-question mx-auto text-center">
  {{ card().frontText || t()["train.noQuestionText"] }}
</div>

<div class="audio-record-train-audio mx-auto">
  @if (hasAudio) {
    <button
      type="button"
      class="train-front-action train-question-audio-action btn btn-icon btn-outline-info rounded-circle waves-effect"
      [class.train-audio-action-playing]="isAudioPlaying()"
      [attr.aria-label]="t()['train.listenQuestion']"
      [title]="t()['train.listenQuestion']"
      (click)="playAudio.emit()"
    >
      <svg class="sa-icon sa-icon-2x sa-bold sa-nofill" aria-hidden="true">
        <use href="/assets/icons/sprite.svg#volume-2"></use>
      </svg>
    </button>
  } @else {
    <div class="audio-record-train-unavailable text-center text-body-secondary">
      {{ t()["train.audioUnavailable"] }}
    </div>
  }
</div>

@if (imageAsset(); as image) {
  <div
    class="audio-record-train-media d-flex align-items-center justify-content-center"
  >
    <img
      class="audio-record-train-image img-fluid"
      [src]="image.url"
      [alt]="imageAlt"
    />
  </div>
}
